var map = {
	"./CD/cd101.png": 45002,
	"./CD/cd102.png": 75585,
	"./CD/cd103.png": 54456,
	"./CD/cd104.png": 87095,
	"./CD/cd105.png": 57870,
	"./CD/cd106.png": 11877,
	"./CD/cd107.png": 45340,
	"./CD/cd108.png": 54827,
	"./CD/cd109.png": 33698,
	"./CD/cd110.png": 61544,
	"./CD/cd111.png": 93585,
	"./CD/cd112.png": 33690,
	"./CD/cd201.png": 20665,
	"./CD/cd202.png": 6658,
	"./CD/cd203.png": 70315,
	"./CD/cd204.png": 78324,
	"./CD/cd205.png": 99453,
	"./CD/cd206.png": 15686,
	"./CD/cd207.png": 783,
	"./CD/cd208.png": 99128,
	"./CD/cd209.png": 71841,
	"./CD/cd210.png": 80699,
	"./CD/cd211.png": 59154,
	"./CD/cd212.png": 7337,
	"./CD/cd301.png": 62760,
	"./CD/cd302.png": 41091,
	"./CD/cd303.png": 51258,
	"./CD/cd304.png": 3317,
	"./CD/cd305.png": 91692,
	"./CD/cd306.png": 42375,
	"./CD/cd307.png": 66590,
	"./CD/cd308.png": 22345,
	"./CD/cd309.png": 98144,
	"./CD/cd310.png": 75126,
	"./CD/cd311.png": 72063,
	"./CD/cd312.png": 35204,
	"./CD/cd313.png": 89101,
	"./CD/cd314.png": 84242,
	"./CD/cd315.png": 99067,
	"./CD/cd316.png": 20736,
	"./CD/cd317.png": 15209,
	"./CD/cd318.png": 69342,
	"./CD/cd401.png": 32735,
	"./CD/cd402.png": 78084,
	"./CD/cd403.png": 18029,
	"./CD/cd404.png": 45522,
	"./CD/cd405.png": 59739,
	"./CD/cd406.png": 81408,
	"./CD/cd407.png": 36233,
	"./CD/cd408.png": 7326,
	"./CD/cd409.png": 25639,
	"./CD/cd410.png": 67601,
	"./CD/cd411.png": 57384,
	"./CD/cd412.png": 10595,
	"./CD/cd413.png": 46490,
	"./CD/cd414.png": 70261,
	"./CD/cd501.png": 78894,
	"./CD/cd502.png": 6725,
	"./CD/cd503.png": 70812,
	"./NTA/bk/bk0101.png": 64298,
	"./NTA/bk/bk0102.png": 13281,
	"./NTA/bk/bk0103.png": 45016,
	"./NTA/bk/bk0104.png": 20183,
	"./NTA/bk/bk0201.png": 89465,
	"./NTA/bk/bk0202.png": 49730,
	"./NTA/bk/bk0202_old.png": 12112,
	"./NTA/bk/bk0203.png": 70859,
	"./NTA/bk/bk0204.png": 20948,
	"./NTA/bk/bk0301.png": 56360,
	"./NTA/bk/bk0302.png": 93219,
	"./NTA/bk/bk0401.png": 74655,
	"./NTA/bk/bk0402.png": 37796,
	"./NTA/bk/bk0501.png": 73774,
	"./NTA/bk/bk0502.png": 92549,
	"./NTA/bk/bk0503.png": 58684,
	"./NTA/bk/bk0504.png": 58643,
	"./NTA/bk/bk0505.png": 7882,
	"./NTA/bk/bk0601.png": 82141,
	"./NTA/bk/bk0602.png": 40902,
	"./NTA/bk/bk0701.png": 54348,
	"./NTA/bk/bk0702.png": 56999,
	"./NTA/bk/bk0703.png": 4510,
	"./NTA/bk/bk0801.png": 95155,
	"./NTA/bk/bk0802.png": 20664,
	"./NTA/bk/bk0901.png": 61442,
	"./NTA/bk/bk0902.png": 9625,
	"./NTA/bk/bk1001.png": 24124,
	"./NTA/bk/bk1002.png": 12855,
	"./NTA/bk/bk1101.png": 92845,
	"./NTA/bk/bk1102.png": 11222,
	"./NTA/bk/bk1103.png": 7551,
	"./NTA/bk/bk1201.png": 84478,
	"./NTA/bk/bk1202.png": 21205,
	"./NTA/bk/bk1203.png": 9580,
	"./NTA/bk/bk1204.png": 42627,
	"./NTA/bk/bk1301.png": 18671,
	"./NTA/bk/bk1302.png": 79860,
	"./NTA/bk/bk1303.png": 17341,
	"./NTA/bk/bk1401.png": 10456,
	"./NTA/bk/bk1402.png": 84947,
	"./NTA/bk/bk1403.png": 29738,
	"./NTA/bk/bk1501.png": 75593,
	"./NTA/bk/bk1502.png": 26802,
	"./NTA/bk/bk1503.png": 75803,
	"./NTA/bk/bk1601.png": 25562,
	"./NTA/bk/bk1602.png": 55729,
	"./NTA/bk/bk1701.png": 72363,
	"./NTA/bk/bk1702.png": 2512,
	"./NTA/bk/bk1703.png": 99417,
	"./NTA/bk/bk1704.png": 6342,
	"./NTA/bk/bk1801.png": 43828,
	"./NTA/bk/bk1802.png": 48943,
	"./NTA/bk/bk1803.png": 83750,
	"./NTA/bx/bx0101.png": 15600,
	"./NTA/bx/bx0102.png": 3243,
	"./NTA/bx/bx0201.png": 27779,
	"./NTA/bx/bx0202.png": 42504,
	"./NTA/bx/bx0301.png": 26514,
	"./NTA/bx/bx0302.png": 17225,
	"./NTA/bx/bx0303.png": 62400,
	"./NTA/bx/bx0401.png": 66181,
	"./NTA/bx/bx0402.png": 38350,
	"./NTA/bx/bx0403.png": 37847,
	"./NTA/bx/bx0501.png": 52820,
	"./NTA/bx/bx0502.png": 74287,
	"./NTA/bx/bx0503.png": 92742,
	"./NTA/bx/bx0601.png": 67847,
	"./NTA/bx/bx0602.png": 65196,
	"./NTA/bx/bx0603.png": 17461,
	"./NTA/bx/bx0701.png": 10102,
	"./NTA/bx/bx0702.png": 24077,
	"./NTA/bx/bx0703.png": 70180,
	"./NTA/bx/bx0801.png": 937,
	"./NTA/bx/bx0802.png": 35794,
	"./NTA/bx/bx0803.png": 84795,
	"./NTA/bx/bx0901.png": 19448,
	"./NTA/bx/bx0902.png": 93939,
	"./NTA/bx/bx0903.png": 55082,
	"./NTA/bx/bx0904.png": 23397,
	"./NTA/bx/bx1001.png": 77666,
	"./NTA/bx/bx1002.png": 60601,
	"./NTA/bx/bx1003.png": 54352,
	"./NTA/bx/bx1004.png": 39727,
	"./NTA/bx/bx1101.png": 76755,
	"./NTA/bx/bx1102.png": 81144,
	"./NTA/bx/bx1103.png": 2273,
	"./NTA/bx/bx1104.png": 3790,
	"./NTA/bx/bx1201.png": 53152,
	"./NTA/bx/bx1202.png": 8187,
	"./NTA/bx/bx1203.png": 59186,
	"./NTA/mn/mn0101.png": 10754,
	"./NTA/mn/mn0102.png": 24761,
	"./NTA/mn/mn0201.png": 41937,
	"./NTA/mn/mn0202.png": 11770,
	"./NTA/mn/mn0203.png": 29347,
	"./NTA/mn/mn0301.png": 63968,
	"./NTA/mn/mn0302.png": 42299,
	"./NTA/mn/mn0303.png": 28082,
	"./NTA/mn/mn0401.png": 12727,
	"./NTA/mn/mn0401_old.png": 36269,
	"./NTA/mn/mn0402.png": 54620,
	"./NTA/mn/mn0501.png": 33446,
	"./NTA/mn/mn0502.png": 14653,
	"./NTA/mn/mn0601.png": 28949,
	"./NTA/mn/mn0602.png": 92222,
	"./NTA/mn/mn0603.png": 68007,
	"./NTA/mn/mn0604.png": 88392,
	"./NTA/mn/mn0701.png": 33956,
	"./NTA/mn/mn0702.png": 19231,
	"./NTA/mn/mn0703.png": 65430,
	"./NTA/mn/mn0801.png": 77659,
	"./NTA/mn/mn0802.png": 99328,
	"./NTA/mn/mn0803.png": 93801,
	"./NTA/mn/mn0901.png": 83882,
	"./NTA/mn/mn0902.png": 32865,
	"./NTA/mn/mn0903.png": 60152,
	"./NTA/mn/mn1001.png": 47060,
	"./NTA/mn/mn1002.png": 37903,
	"./NTA/mn/mn1101.png": 2949,
	"./NTA/mn/mn1102.png": 32590,
	"./NTA/mn/mn1201.png": 99894,
	"./NTA/mn/mn1202.png": 90573,
	"./NTA/mn/mn1203.png": 64420,
	"./NTA/qn/qn0101.png": 60746,
	"./NTA/qn/qn0102.png": 9729,
	"./NTA/qn/qn0103.png": 25112,
	"./NTA/qn/qn0104.png": 279,
	"./NTA/qn/qn0105.png": 57262,
	"./NTA/qn/qn0201.png": 69561,
	"./NTA/qn/qn0202.png": 29826,
	"./NTA/qn/qn0203.png": 50955,
	"./NTA/qn/qn0301.png": 36456,
	"./NTA/qn/qn0302.png": 73315,
	"./NTA/qn/qn0303.png": 51738,
	"./NTA/qn/qn0401.png": 54751,
	"./NTA/qn/qn0402.png": 17892,
	"./NTA/qn/qn0501.png": 53870,
	"./NTA/qn/qn0502.png": 72645,
	"./NTA/qn/qn0503.png": 55132,
	"./NTA/qn/qn0504.png": 38739,
	"./NTA/qn/qn0601.png": 62237,
	"./NTA/qn/qn0602.png": 20998,
	"./NTA/qn/qn0701.png": 34444,
	"./NTA/qn/qn0702.png": 37095,
	"./NTA/qn/qn0703.png": 84606,
	"./NTA/qn/qn0704.png": 67697,
	"./NTA/qn/qn0705.png": 57480,
	"./NTA/qn/qn0706.png": 94339,
	"./NTA/qn/qn0707.png": 46586,
	"./NTA/qn/qn0801.png": 75251,
	"./NTA/qn/qn0802.png": 760,
	"./NTA/qn/qn0803.png": 85377,
	"./NTA/qn/qn0804.png": 32910,
	"./NTA/qn/qn0805.png": 75927,
	"./NTA/qn/qn0901.png": 41538,
	"./NTA/qn/qn0902.png": 89721,
	"./NTA/qn/qn0903.png": 92816,
	"./NTA/qn/qn0904.png": 35663,
	"./NTA/qn/qn0905.png": 96646,
	"./NTA/qn/qn1001.png": 4220,
	"./NTA/qn/qn1002.png": 92951,
	"./NTA/qn/qn1003.png": 19310,
	"./NTA/qn/qn1101.png": 72941,
	"./NTA/qn/qn1102.png": 91318,
	"./NTA/qn/qn1103.png": 87647,
	"./NTA/qn/qn1104.png": 36320,
	"./NTA/qn/qn1201.png": 64574,
	"./NTA/qn/qn1202.png": 1301,
	"./NTA/qn/qn1203.png": 89676,
	"./NTA/qn/qn1204.png": 39075,
	"./NTA/qn/qn1205.png": 32890,
	"./NTA/qn/qn1206.png": 9137,
	"./NTA/qn/qn1301.png": 98767,
	"./NTA/qn/qn1302.png": 76308,
	"./NTA/qn/qn1303.png": 97437,
	"./NTA/qn/qn1304.png": 4642,
	"./NTA/qn/qn1305.png": 68299,
	"./NTA/qn/qn1306.png": 86544,
	"./NTA/qn/qn1307.png": 18649,
	"./NTA/qn/qn1401.png": 90552,
	"./NTA/qn/qn1402.png": 87424,
	"./NTA/qn/qn1403.png": 87453,
	"./NTA/si/si0101.png": 91020,
	"./NTA/si/si0102.png": 59495,
	"./NTA/si/si0103.png": 88158,
	"./NTA/si/si0104.png": 24273,
	"./NTA/si/si0105.png": 84328,
	"./NTA/si/si0106.png": 21187,
	"./NTA/si/si0107.png": 99610,
	"./NTA/si/si0201.png": 58303,
	"./NTA/si/si0202.png": 44740,
	"./NTA/si/si0203.png": 70893,
	"./NTA/si/si0204.png": 89330,
	"./NTA/si/si0301.png": 99950,
	"./NTA/si/si0302.png": 71749,
	"./NTA/si/si0303.png": 42332,
	"./NTA/si/si0304.png": 42291,
	"./NTA/si/si0305.png": 87082,
	"./NTA/si/si9561.png": 71349,
	"./StoriesAsset/Compare.png": 44288,
	"./StoriesAsset/HDI.png": 7932,
	"./StoriesAsset/MentalHealth.png": 43744,
	"./StoriesAsset/MentalHealthFacilities.png": 48955,
	"./StoriesAsset/Nutrition.png": 71969,
	"./StoriesAsset/WorkWealth.png": 45473
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 50055;
module.exports = webpackAsyncContext;